import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { PatientPresence } from '@common/customControls/bariatrics';

export type BariPreGroupSessionData = {
    aanwezigheid: PatientPresence | null;
    datum_en_tijd: string | Date | null;
};

export type BariPreGroupSessionReadKey = keyof BariPreGroupSessionData;
export type BariPreGroupSessionReadLabel = 'Aanwezigheid' | 'Datum en tijd';

export const bariPreGroupSessionReadSchema: TypedReadSchema<
    BariPreGroupSessionReadKey,
    BariPreGroupSessionReadLabel
>[] = [
    {
        items: [
            { key: 'aanwezigheid', label: 'Aanwezigheid' },
            { key: 'datum_en_tijd', label: 'Datum en tijd' },
        ],
    },
];

const bariPreGroupSessionFinal: TypedSchema<BariPreGroupSessionData> = {
    aanwezigheid: Koi.koi().enum(PatientPresence),
    datum_en_tijd: Koi.string().isoDate().allow(null),
};

const bariPreGroupSessionDraft = {
    never_valid: Koi.valid(), // draft version of this activity is not allowed, validation will always fail
};

export const bariPreGroupSessionDraftSchema = Koi.object(bariPreGroupSessionDraft);
export const bariPreGroupSessionFinalSchema = Koi.object(bariPreGroupSessionFinal);
